<template>
  <div>
    <h2 v-if="showTitle" class="mb-2">{{ $t("date")}}</h2>
    <div class="flex overflow-x-auto space-x-3 show-scroll pb-2">
      <div
        v-for="(day, index) in days"
        :key="index"
        ref="dayRef"
        @click="selectDate(day)"
        :class="[ 
          'min-w-[70px] flex-shrink-0 rounded-xl text-center cursor-pointer p-2 border transition-all optionButton',
          selectedDate === day.date
            ? 'walletButton'
            : 'walletButtonDisabled'
        ]"
      >
        <div class="text-xs uppercase">{{ day.month }}</div>
        <div class="sm:text-sm text-xl font-semibold">{{ day.day }}</div>
        <div class="sm:text-xs text-sm">{{ day.weekday }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { formatDate, capitalizeFirstLetter } from '@/helpers/dateHelper';

interface DayInfo {
  date: string;
  day: string;
  month: string;
  weekday: string;
}

export default defineComponent({
  name: 'DaysSelector',
  emits: ['getAvailability'],
  props: {
    selected: {
      type: String,
      required: false,
      default: '',
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      days: [] as DayInfo[],
      selectedDate: this.selected
        ? formatDate(new Date(this.selected), 'yyyy-MM-dd') // no hace falta locale por que solo es para el funcionamiento interno del componente
        : '',
    };
  },
  watch: {
    selectedDate() {
      this.$nextTick(() => this.scrollToSelected());
    },
  },
  created() {
    const today = new Date();
    const userLang = navigator.language || 'en-US';

    for (let i = 0; i < 30; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);

      const weekday = capitalizeFirstLetter(
        date.toLocaleDateString(userLang, { weekday: 'short' })
      );
      const month = date
        .toLocaleDateString(userLang, { month: 'short' })
        .toUpperCase();
      const day = date.toLocaleDateString(userLang, { day: '2-digit' });

      this.days.push({
        date: formatDate(date, 'yyyy-MM-dd'),
        day,
        month,
        weekday,
      });
    }
  },
  mounted() {
    this.scrollToSelected();
  },
  methods: {
    selectDate(day: DayInfo) {
      this.selectedDate = day.date;
      const fullDate = new Date(this.selectedDate);
      this.$emit('getAvailability', fullDate);
    },
    scrollToSelected() {
      const items = this.$refs.dayRef as HTMLElement[] | HTMLElement;
      const itemList = Array.isArray(items) ? items : [items];

      for (const item of itemList) {
        if (item.classList.contains('walletButton')) {
          item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          break;
        }
      }
    },
  },
});
</script>


<style scoped>
.optionButton.selected {
  background: var(--color3) !important;
}
.optionButton {
    transition: none !important;
}
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::v-deep(.show-scroll) {
  scrollbar-width: auto;
  scrollbar-color:#0458E2 #01162a;
}
::v-deep(.show-scroll::-webkit-scrollbar) {
  height: 8px;
}
::v-deep(.show-scroll::-webkit-scrollbar-thumb) {
  background-color: #0458E2;
  border-radius: 4px;
}
::v-deep(.show-scroll::-webkit-scrollbar-track) {
  background-color:#01162a;
}
</style>
